<div class="clo-editor clo-lite-editor">
<div class="chart enable-graph-container">
  <span class="enable-graph-label">Enable feature</span><input type="checkbox" [checked]="enableChecked"
  class="primary-checkbox" id="CloLite-enableGraph" (change)="enableGraph($event.target.checked)" />
  <label for="CloLite-enableGraph" aria-label="Enable feature"><span id="CloLite-enable-feature-checkbox" class="extra-border-enablefeat"></span></label>
</div>
<div class="clo-table-container">
  <div class="schedule-heading">
    <div class="schedule" [ngClass]="{ 'schedule-disabled': disableGraph }">Schedule</div>
  </div>
  <div class="schedule-editor">
    <div id="CLO-chart-container" class="chart schedule-panel" [ngClass]="disableGraph ? 'disable-graph' : 'enable-graph'" [attr.aria-disabled]="disableGraph">

      <h3 class="numeric-heading">Numeric generator</h3>
              <button id="CloLite-clear-numericFields"
                type="button"
                class="numeric-clear"
                [disabled]="disableGraph || disableNumericClear"
                (click)="clearNumericFields()"
                [ngClass]="{'disable-numeric-clear': disableNumericClear===true}">
                Clear fields
              </button>
            <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" novalidate>
              @if (cloLiteSchema?.properties?.CloLiteMaximumWorkingHours) {
                <div class="row chart-rows">
                  <div class="col-5">CLO active hours</div>
                  <div class="col-7 form-group">
                    <input type="text"
                      id="CloLite-activeHours-input" class="form-control" formControlName="cloHour" maxlength="6" size="4" (keypress)="numberOnly($event)"
                      [ngClass]="{ 'is-invalid': submitted && f.cloHour.errors, 'initial-input': afterClearField===true }"
                      (keyup)="inputValueChanged($event)" /><span class="field-suffix">x 1000 h</span>
                    </div>
                  </div>
                }
                @if (cloLiteSchema?.properties?.CloLiteNumberOfSteps) {
                  <div class="row chart-rows">
                    <div class="col-5">Number of steps</div>
                    <div class="col-7 form-group">
                      <input type="text"
                        id="CloLite-steps-input" class="form-control" formControlName="cloSteps" maxlength="3" size="4" (keypress)="numberOnly($event)"
                        [ngClass]="{ 'is-invalid': submitted && f.cloSteps.errors, 'initial-input': afterClearField===true }"
                        (keyup)="inputValueChanged($event)" />
                      </div>
                    </div>
                  }
                  @if (cloLiteSchema?.properties?.CloLiteInitialPowerLevel) {
                    <div class="row chart-rows">
                      <div class="col-5">Initial output level</div>
                      <div class="col-7 form-group">
                        <input type="text"
                          id="CloLite-initialOutputLevel-input" class="form-control" formControlName="initialOutput" maxlength="3" (keypress)="numberOnly($event)"
                          size="4"
                          [ngClass]="{ 'is-invalid': submitted && f.initialOutput.errors, 'initial-input': afterClearField===true }"
                          (keyup)="inputValueChanged($event)" /><span class="field-suffix"> %</span>
                        </div>
                      </div>
                    }
                    @if (cloLiteSchema?.properties?.CloLiteFinalPowerLevel) {
                      <div class="row chart-rows">
                        <div class="col-5">Final output level</div>
                        <div class="col-7 form-group">
                          <input type="text"
                            id="CloLite-finalOutputLevel-input" class="form-control" formControlName="finalOutput" maxlength="3" (keypress)="numberOnly($event)"
                            size="4"
                            [ngClass]="{ 'is-invalid': submitted && f.finalOutput.errors, 'initial-input': afterClearField===true }"
                            (keyup)="inputValueChanged($event)" /><span class="field-suffix"> %</span>
                          </div>
                        </div>
                      }
                    </form>
            </div>
          </div>
        </div>
      </div>
